import { Placement, Tooltip } from '@aus-platform/design-system';
import classNames from 'classnames';
import { isUndefined } from 'lodash';
import React, { useLayoutEffect, useRef, useState } from 'react';

export const OverflowTextTooltip: React.FC<{
  text: string;
  maxLength?: number;
  className?: string;
  tooltipPlacement?: Placement;
  tooltipClassName?: string;
}> = ({
  text,
  maxLength,
  className,
  tooltipPlacement = Placement.Right,
  tooltipClassName,
}) => {
  // State
  const [isOverflowing, setIsOverflowing] = useState(false);

  // Refs.
  const contentRef = useRef<HTMLDivElement>(null);

  // Constants.
  const containerWidthStyle = isUndefined(maxLength)
    ? undefined
    : { maxWidth: maxLength - 3 + 'ch' };

  const containerClassName = classNames('overflow-text-container', className);

  useLayoutEffect(() => {
    const node = contentRef.current;
    if (!node) {
      return;
    }

    const hasOverflow = node.scrollWidth > node.clientWidth;
    setIsOverflowing((previous) =>
      previous === hasOverflow ? previous : hasOverflow,
    );
  }, [text, maxLength]);

  const contentDiv = (
    <div
      ref={contentRef}
      className={containerClassName}
      style={containerWidthStyle}
    >
      {text}
    </div>
  );

  return isOverflowing ? (
    <Tooltip
      hoverText={text}
      placement={tooltipPlacement}
      className={tooltipClassName}
    >
      {contentDiv}
    </Tooltip>
  ) : (
    contentDiv
  );
};
